import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=5395ccaa&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=5395ccaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395ccaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5395ccaa')) {
      api.createRecord('5395ccaa', component.options)
    } else {
      api.reload('5395ccaa', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=5395ccaa&scoped=true&", function () {
      api.rerender('5395ccaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xRQKNzuFwbny/JS/comp/CookieBox.vue"
export default component.exports